export default "__VITE_ASSET__BLStO$rd__"